import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';

export const AddToBasketSectionSkeleton: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <section className={className} style={style}>
      <SkeletonBlock $width="30%" />
      <SkeletonBlock $height="50px" />

      <SkeletonBlock $width="30%" />
      <SkeletonBlock $height="50px" />
    </section>
  );
};
